module.exports = __webpack_public_path__ + "img/bbc_article_button.0d29956b.png";